import React from 'react';
import { render } from 'react-dom';

import createApp from '../../src/app';

function requireStores () {
    const context = require.context('./stores', true, /\.js$/);
    context.keys().forEach(context);
}

function requireCoreStores () {
    const context = require.context('../../src/stores', true, /\.js$/);
    context.keys().forEach(context);
}

function onInit () {
    requireStores();
    requireCoreStores();
}

/*
 * You might think that since this function is identical to <project>/src/main.js
 * that this could be moved to <project>/src/app.js, but sadly that breaks
 * hot module reloading.
 */
function onRender (containerEl) {
    const renderApp = () => {
        const Root = require('./components/Root').default;
        render(<Root />, containerEl);
    };

    if (module.hot) {
        module.hot.accept('./components/Root.js', renderApp);
    }
    renderApp();
}

const app = window.OTRL = createApp(onInit, onRender);
export default app;
